import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

function NuevoComite(props) {
	const { guardar, setQueMostrar } = props

	const datosComiteInicial = {
		nombre: '',
		contenido: '',
		orden: '',
	}
	const [datosComite, setDatosComite] = useState(datosComiteInicial)

	const handleClose = () => {
		setQueMostrar('')
		setDatosComite(datosComiteInicial)
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datosComite,
		}

		guardar(data)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datosComite }
		datosCopia[key] = value
		setDatosComite(prev => datosCopia)
	}

	const handleSeleccionImagen = (files) => {
		setDatosComite({ ...datosComite, imagen: files[0] })
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Nuevo comité" />
			<Offcanvas.Body>
				<h1>Datos del comité</h1>
				<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="comite-nombre">
										<FormLabel>Nombre</FormLabel>
										<Form.Control
											value={datosComite.nombre}
											type="text"
											onChange={(e) => handleChange(e.target.value, 'nombre')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="comite-contenido">
										<Form.Label>Contenido</Form.Label>
										<Form.Control
											as="textarea" rows={5}
											value={datosComite.contenido}
											onChange={(e) => handleChange(e.target.value, 'contenido')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="comite-orden">
										<FormLabel>Orden</FormLabel>
										<Form.Control
											value={datosComite.orden}
											type="number"
											onChange={(e) => handleChange(e.target.value, 'orden')}
										/>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col sm={12} md={6}>
						<FileUpload
							title="Foto"
							accept=".png, .jpg, .jpeg"
							buttonText="Elegir"
							buttonTextSingular="imagen"
							updateFiles={handleSeleccionImagen}
						/>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default NuevoComite